import { OnDestroy } from '@angular/core';
import { from, Observable, of, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { UserService } from 'services/user/user.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/user/user.service";
var AuthenticatedGuard = /** @class */ (function () {
    function AuthenticatedGuard(userService) {
        var _this = this;
        this.userService = userService;
        this._subrelease = new Subject();
        this._isAuthenticated = false; // Default to not authenticated.
        this.userService.UserSubject.pipe(takeUntil(this._subrelease)).subscribe(function (user) {
            _this._isAuthenticated = user && (user.AuthToken != null && user.AuthToken !== '');
            _this._currentRole = user && user.CurrentRole;
        });
    }
    AuthenticatedGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        // At a minimum, only allow access if we have a valid authtoken stored for the current user.
        var isAuth = this._isAuthenticated;
        // If there is optional data present, particularly the 'roles' array, we must also check to ensure that the
        // current role of the user allows for this state to be reached.
        if (route.data != null && route.data['roles'] != null && route.data['roles'].length > 0) {
            // If we have limited roles, but no current role established, that is an automatic failure.
            if (this._currentRole == null) {
                return false;
            }
            var roles = route.data['roles'];
            var matched = roles.find(function (rolename) {
                if (rolename.toLowerCase() === _this._currentRole.toLowerCase()) {
                    return true;
                }
            });
            return matched != null;
        }
        return this._isAuthenticated;
    };
    AuthenticatedGuard.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    AuthenticatedGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthenticatedGuard_Factory() { return new AuthenticatedGuard(i0.inject(i1.UserService)); }, token: AuthenticatedGuard, providedIn: "root" });
    return AuthenticatedGuard;
}());
export { AuthenticatedGuard };
var UnsavedChangesService = /** @class */ (function () {
    function UnsavedChangesService() {
        this._nativeListener = null;
    }
    UnsavedChangesService.prototype._nativeChecker = function (checker, event) {
        var isClean = checker != null ? checker(true) : false;
        if (!isClean) {
            var msg = 'There may be unsaved changes on this page. Do you wish to continue leaving the page?';
            event = event || window.event;
            if (event) {
                event.returnValue = msg;
            }
            return msg;
        }
        else {
            return;
        }
    };
    // #region Clear Tracking Method
    UnsavedChangesService.prototype.ClearTracking = function () {
        if (this._nativeListener) {
            window.removeEventListener('beforeunload', this._nativeListener);
            this._nativeListener = null;
        }
        this._tracker = null;
    };
    // #endregion
    // #region Check Tracker Method
    UnsavedChangesService.prototype.CheckTracker = function () {
        var self = this;
        if (self._tracker != null) {
            var result = self._tracker();
            var obsResult = null;
            if (result instanceof Promise) {
                obsResult = from(result);
            }
            else if (!(result instanceof Observable)) {
                obsResult = of(result).pipe(take(1));
            }
            else {
                obsResult = result;
            }
            return obsResult;
        }
        else {
            return of(true).pipe(take(1));
        }
    };
    // #endregion
    // #region Is Tracking Method
    UnsavedChangesService.prototype.IsTracking = function () {
        var self = this;
        return !!self._tracker;
    };
    // #endregion
    // #region Set Tracking Method
    UnsavedChangesService.prototype.SetTracking = function (tracker) {
        var self = this;
        if (self._nativeListener) {
            self.ClearTracking();
        }
        self._nativeListener = self._nativeChecker.bind(window, tracker);
        window.addEventListener('beforeunload', self._nativeListener);
        this._tracker = tracker;
    };
    UnsavedChangesService.ngInjectableDef = i0.defineInjectable({ factory: function UnsavedChangesService_Factory() { return new UnsavedChangesService(); }, token: UnsavedChangesService, providedIn: "root" });
    return UnsavedChangesService;
}());
export { UnsavedChangesService };
var UnsavedChangesGuard = /** @class */ (function () {
    function UnsavedChangesGuard(unsavedChangesSvc) {
        this.unsavedChangesSvc = unsavedChangesSvc;
    }
    UnsavedChangesGuard.prototype.canDeactivate = function (target) {
        if (this.unsavedChangesSvc.IsTracking()) {
            return target.CanDeactivate ? target.CanDeactivate() : true;
        }
        else {
            return true;
        }
    };
    UnsavedChangesGuard.ngInjectableDef = i0.defineInjectable({ factory: function UnsavedChangesGuard_Factory() { return new UnsavedChangesGuard(i0.inject(UnsavedChangesService)); }, token: UnsavedChangesGuard, providedIn: "root" });
    return UnsavedChangesGuard;
}());
export { UnsavedChangesGuard };
